import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Filter, IFilter } from "./Filter";
import { Dialog } from "primereact/dialog";
import { endOfMonth, format, startOfMonth } from "date-fns";

interface Iprops { toast: any, reload: boolean, reloadData: () => void, }

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState<any>({
        data: [],
        loading: false
    });
    const [leadData, setLeadData] = useState<any[]>([]);
    const [leadLoading, setLeadLoading] = useState(false);
    const [renewDialog, setRenewDialog] = useState(false);
    const [expiredDialog, setExpiredDialog] = useState(false);
    const [renewalDueDialog, setRenewalDueDialog] = useState(false);
    const [filter, setFilter] = useState<IFilter>({
        fromDate: startOfMonth(new Date()),
        toDate: new Date(),
        assigned_To: []
    });

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    useEffect(() => {
        if (filter.fromDate && filter.toDate) {
            loadTableData();
        }
    }, [filter, lazyParams, props.reload]);



    //     if ((filter.fromDate && !filter.toDate) || (!filter.fromDate && filter.toDate)) {
    //         props.toast.current.show({
    //             severity: "warn", summary: "Validation", detail: "From Date and To Date both are required", life: 3000 }); return;
    //     }
    //     const fromDate = filter.fromDate ? new Date(filter.fromDate).toISOString() : "";
    //     const toDate = filter.toDate ? new Date(filter.toDate).toISOString() : ""; 
    //     setTableData((prev: any) => ({ ...prev, loading: true })); 
    //     const query = `fromDate=${fromDate}&toDate=${toDate}${filter.assigned_To ? `&userId=${filter.assigned_To}` : "" }`;
    //     const response = await Fetch( "Device/renewal-report", "GET", null, query, props.toast );
    //     if (response) {
    //         const data = await response.json();
    //         setTableData({ data: data, loading: false }); 
    //     } else {
    //         setTableData((prev: any) => ({ ...prev, loading: false })); 
    //     }
    // };


    const loadTableData = async () => {
        if ((filter.fromDate && !filter.toDate) || (!filter.fromDate && filter.toDate)) {
            props.toast.current.show({
                severity: "warn",
                summary: "Validation",
                detail: "From Date and To Date both are required",
                life: 3000
            });
            return;
        }

        const fromDate = filter.fromDate ? new Date(filter.fromDate).toISOString() : "";
        const toDate = filter.toDate ? new Date(filter.toDate).toISOString() : "";

        const userQuery = filter.assigned_To?.length
            ? filter.assigned_To.map(id => `userId=${id}`).join("&")
            : "";

        const query = `lazyParams=${JSON.stringify(lazyParams)}&fromDate=${fromDate}&toDate=${toDate}${userQuery ? `&${userQuery}` : ""}`;

        setTableData((prev: any) => ({ ...prev, loading: true }));

        const response = await Fetch("Device/renewal-report", "GET", null, query, props.toast);

        if (response) {
            const data = await response.json();
            setTableData({ data: data.result, loading: false });
        } else {
            setTableData((prev: any) => ({ ...prev, loading: false }));
        }
    };
    const loadRenewalDetails = async (userId: number, type: string) => {
        if ((filter.fromDate && !filter.toDate) || (!filter.fromDate && filter.toDate)) {
            props.toast.current.show({ severity: "warn", summary: "Validation", detail: "From Date and To Date both are required", life: 3000 }); return;
        }
        const fromDate = filter.fromDate ? new Date(filter.fromDate).toISOString() : "";
        const toDate = filter.toDate ? new Date(filter.toDate).toISOString() : "";
        setLeadLoading(true);
        const query = `userId=${userId}&type=${type}&fromDate=${fromDate}&toDate=${toDate}`;
        const response = await Fetch("Device/renewal-details", "GET", null, query, props.toast);
        if (response) {
            const data = await response.json();
            setLeadData(data);
            if (type === "renewed") setRenewDialog(true);
            if (type === "expired") setExpiredDialog(true);
            if (type === "renewalDue") setRenewalDueDialog(true);
        }

        setLeadLoading(false);
    };

    const clickableBody = (field: string, type: string) => {
        return (rowData: any) => (
            <span
                style={{ cursor: "pointer", color: "#2563eb", fontWeight: 600 }}
                onClick={() => loadRenewalDetails(rowData.userId, type)}
            >
                {rowData[field]}
            </span>
        );
    };


    const calculateTotal = (field: string) => {
        let total = 0;
        if (tableData.data) {
            tableData.data.forEach((item: any) => {
                total += (item[field] || 0);
            });
        }
        return total;
    };

    return (
        <>
            <Filter header={<div>Filter</div>} loading={tableData.loading} filter={filter} setFilter={setFilter} />

            <DataTable value={tableData.data} loading={tableData.loading} stripedRows size="small" showGridlines
                responsiveLayout="scroll" scrollHeight="75vh"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                <Column header="S.No" body={(rowData, options) => options.rowIndex + 1} footer="TOTAL"/>
                <Column field="userName" header="User Name" />
                <Column field="renewed" header="Renewal Done" body={clickableBody("renewed", "renewed")} footer={calculateTotal("renewed")} />
                <Column field="expired" header="Expired" body={clickableBody("expired", "expired")} footer={calculateTotal("expired")} />
                <Column field="renewalDue" header="Renewal Due" body={clickableBody("renewalDue", "renewalDue")} footer={calculateTotal("renewalDue")} />
            </DataTable>


            {/* RENEWED */}
            <Dialog header="Renewed Devices" visible={renewDialog} style={{ width: "65vw" }} onHide={() => setRenewDialog(false)}    >
                <DataTable value={leadData} loading={leadLoading} stripedRows size="small">
                    <Column header="S.No" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="customername" header="Customer Name" />
                    <Column field="macAddress" header="Mac Address" />
                    <Column field="deviceName" header="Device Name" />
                    <Column header="Renew History" body={(rowData) => (
                        <div>
                            {rowData.renewHistory.map((d: any, i: number) => (
                                <div key={i}>
                                    {format(new Date(d + "Z"), "dd/MM/yyyy hh:mm a")}
                                </div>
                            ))}
                        </div>
                    )}
                    />

                </DataTable>
            </Dialog>

            {/* EXPIRED */}

            <Dialog header="Expired Devices" visible={expiredDialog} style={{ width: "65vw" }} onHide={() => setExpiredDialog(false)}  >
                <DataTable value={leadData} loading={leadLoading} stripedRows size="small">
                    <Column header="S.No" body={(leadData, options) => options.rowIndex + 1} />
                    <Column field="customername" header="Customer Name" />
                    <Column field="macAddress" header="Mac Address" />
                    <Column field="deviceName" header="Device Name" />
                    <Column field="date" header="Expiry Date" body={(rowData) => format(new Date(rowData.date + "Z"), "dd/MM/yyyy")} />
                </DataTable>
            </Dialog>

            {/* RENEWAL DUE */}

            <Dialog header="Renewal Due" visible={renewalDueDialog} style={{ width: "65vw" }} onHide={() => setRenewalDueDialog(false)} >
                <DataTable value={leadData} loading={leadLoading} stripedRows size="small">
                    <Column header="S.No" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="customername" header="Customer Name" />
                    <Column field="macAddress" header="Mac Address" />
                    <Column field="deviceName" header="Device Name" />
                    <Column field="date" header="Expiry Date" body={(rowData) => format(new Date(rowData.date + "Z"), "dd/MM/yyyy")} />
                </DataTable>
            </Dialog>

        </>
    );
};